import { Dispatch } from 'react-redux';
import * as types from "./action-types";
import { AuthActionCreators, IApplicationState } from '../index';
import { Utility } from '../../services/utility';
import { IShortCodeLink, ISaveShortCodeLinkRequest, IBaseResponse } from '../../models/index';
import { ISaveShortCodeLinkResponse } from '../../models/save-short-code-link-response';
import { IListShortCodeLinksResponse } from '../../models/list-short-code-links-response';

export const ActionCreators = {
    getNewShortCode: () => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + "/shortcode/getnewshortcode"
        }

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    createShortCodeLink: (shortCode: string, link: string)=> (dispatch: Dispatch<IApplicationState>): Promise<ISaveShortCodeLinkResponse> => {
        var options = {
            url: __API__ + "/shortcode/createshortcodelink",
            data: {
                link: link,
                shortCode: shortCode
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: ISaveShortCodeLinkResponse) => {

            return Promise.resolve(response);
        });
    },
    listShortCodeLinks: () => (dispatch: Dispatch<IApplicationState>): Promise<IListShortCodeLinksResponse> => {
        var options = {
            url: __API__ + "/shortcode/listshortcodelinks"
        }

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IListShortCodeLinksResponse) => {
            return Promise.resolve(response);
        });
    },
    updateShortCodeLink: (id: string, isActive: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<ISaveShortCodeLinkResponse> => {
        var options = {
            url: __API__ + "/shortcode/updateshortcodelink",
            data: {
                id: id,
                isActive: isActive
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: ISaveShortCodeLinkResponse) => {

            return Promise.resolve(response);
        });
    }

}